"use client";

import CssBaseline from "@mui/material/CssBaseline";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v13-appRouter";
import { ThemeProvider } from "@mui/material/styles";
import theme from "@portal/theme/theme";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import PortalSentryScope from "./global/Sentry/PortalSentryScope";
import { getQueryClient } from "./global/QueryClient";
import PostHogPageView from "./global/PostHog/PostHogPageView";
import { PostHogProvider } from "./global/PostHog/PostHog";
import { SnackbarProvider } from "./global/Snackbar/Snackbar";
import { TrpcProvider } from "./global/TrpcClient/TrpcProvider";

export const Providers = ({ children }: { children: React.ReactNode }) => {
  const queryClient = getQueryClient();

  return (
    <PostHogProvider>
      <SnackbarProvider>
        <AppRouterCacheProvider>
          <PostHogPageView />
          <PortalSentryScope />
          <CssBaseline />
          <ThemeProvider theme={theme}>
            <TrpcProvider queryClient={queryClient}>
              <QueryClientProvider client={queryClient}>
                {children}
                <ReactQueryDevtools initialIsOpen={false} />
              </QueryClientProvider>
            </TrpcProvider>
          </ThemeProvider>
        </AppRouterCacheProvider>
      </SnackbarProvider>
    </PostHogProvider>
  );
};
